import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'avatar',
  props: {
    avatar: {
      default: ''
    },
    size: {
      default: '40'
    },
    name: {
      default: ''
    },
    avatarStyle: {
      default: ''
    },
    largeFontSize: {
      type: Boolean,
      default: false
    },
    smallFontSize: {
      type: Boolean,
      default: false
    },
    lazySrc: {
      type: Boolean,
      default: false
    },
    nameFormatType: {
      default: ''
    },
    rounded: {
      default: '50%'
    },
    backgroundColor: {
      default: '--v-background-base'
    },
    transparent: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const isErrorImage = ref(false);
    const concatFirstAndLastNameInitials = computed(() => {
      if (props.name) {
        var _lastName;
        const fullName = props.name.split(' ');
        const firstName = fullName.shift();
        let lastName = '';
        if (props.nameFormatType === 'first-second-name') {
          lastName = fullName[0] || '';
        } else {
          lastName = fullName.pop() || '';
        }
        return ((firstName === null || firstName === void 0 ? void 0 : firstName.charAt(0)) || '') + (((_lastName = lastName) === null || _lastName === void 0 ? void 0 : _lastName.charAt(0)) || '');
      } else {
        return '';
      }
    });
    const errorImage = () => {
      isErrorImage.value = true;
    };
    return {
      __sfc: true,
      props,
      isErrorImage,
      concatFirstAndLastNameInitials,
      errorImage
    };
  }
});